export const getCheapestByPrice = items => {
  return items?.reduce((cheapest, current) => {
    if (!cheapest) {
      return current;
    }

    const currentPrice = current?.cluster?.composition_price?.total ?? Infinity;

    const cheapestPrice =
      cheapest?.cluster?.composition_price?.total ?? Infinity;

    if (currentPrice < cheapestPrice) {
      return current;
    }

    return cheapest;
  }, null);
};

export const getElem = (element, isCustomSearch) => {
  if (!isCustomSearch) return element;

  const cheapest = getCheapestByPrice(element?.combinations);

  return cheapest ?? element;
};

export const getClusterId = elem => elem?.cluster_id;

export const getSafeClusterId = (clusterId, isCustomSearch) =>
  `${isCustomSearch ? 'custom-cluster' : 'normal'}-${clusterId}`;

export const hasManyOptions = options => options?.length >= 3;

export const buildClusterBookingBody = (
  element,
  activeRadio,
  activeCluster
) => {
  const commonTitle = element.common.common_title;

  const legsSelect = commonTitle.map((common, index) => ({
    ...common,
    options: [activeRadio[index]],
  }));

  const legsSelectUnit = commonTitle.map((common, index) => ({
    ...common,
    ...activeRadio[index],
  }));

  const body = {
    id_integration: 2,
    operation_id: element.operation_id,
    options_ids: activeRadio.map(data => data.id_option),
    cluster: {
      ...activeCluster,
      legs: legsSelect,
    },
  };

  return { body, legsSelectUnit };
};
